import { NgModule, ModuleWithProviders, CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonSharedModule } from '@common/shared/common-shared.module';
import { MATERIAL_MODULES, CDK_MODULES } from './material-modules';

import { BitfLoaderComponent } from '@bitf/core/components/ui/loader/bitf-loader.component';
import { SearchComponent } from './components/search/search.component';
import { HeaderComponent } from '@web/core/components/header/header.component';
import { HeaderLogoComponent } from '@web/core/components/header-logo/header-logo.component';
import { NewsContainerComponent } from './components/news-container/news-container.component';
import { NewsComponent } from './components/news/news.component';
import { BitfSafeHtml } from '@common/libs/bitforce/pipes/bitf-safe-html.pipe';
import { FullCalendarModule } from '@fullcalendar/angular';
import { CalendarComponent } from './components/calendar/calendar.component';
import { NewsDialogComponent } from './components/news-dialog/news-dialog.component';
import { CalendarContainerComponent } from './components/container-calendar/calendar-container.component';
// tslint:disable:max-line-length
import { CalendarEventDialogComponent } from './components/calendar-event-dialog/calendar-event-dialog.component';
import { BitfMatPaginatorComponent } from '@bitf/core/components/ui/paginator/material/bitf-mat-paginator.component';
import { BitfMatSortComponent } from '@common/libs/bitforce/core/components/ui/sort/material/bitf-mat-sort.component';
import { BitfUiRoleManagerDirective } from '@common/libs/bitforce/directives/ui-role-manager/bitf-ui-role-manager.directive';
import { DateAdapterService } from '@web/core/services/date-adapter.service';
import { DateAdapter } from '@angular/material/core';
import { BitfDynamicLocaleService } from '@common/libs/bitforce/core/services/locale/bitf-dynamic-locale.service';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { BitfMatFormOptionComponent } from '@common/libs/bitforce/core/components/ui/form-item/material/mat-form-option/bitf-mat-form-option.component';
import { BitfMatFormItemComponent } from '@common/libs/bitforce/core/components/ui/form-item/material/mat-form-item/bitf-mat-form-item.component';
import { BitfMatInfiniteScrollTriggerComponent } from '@common/libs/bitforce/core/components/ui/infinite-scroll/material/bitf-mat-infinite-scroll-trigger/bitf-mat-infinite-scroll-trigger.component';
import { BitfCkFormItemComponent } from '@common/libs/bitforce/core/components/ui/ck-form-item/bitf-ck-form-item.component';

import { CarouselModule } from 'primeng/carousel';
import { FsContainerComponent } from './components/file-system/fs-container/fs-container.component';
import { FsCardItemComponent } from './components/file-system/fs-card-item/fs-card-item.component';
import { FsListItemComponent } from './components/file-system/fs-list-item/fs-list-item.component';
import { FsActionsComponent } from './components/file-system/fs-actions/fs-actions.component';
import { BitfMatBreadcrumbsComponent } from '@common/libs/bitforce/core/components/ui/breadcrumbs/material/bitf-mat-breadcrumbs/bitf-mat-breadcrumbs.component';
import { FsFilterComponent } from './components/file-system/fs-filter/fs-filter.component';
import { FsCreateUpdateFilesComponent } from './components/file-system/fs-create-update-files/fs-create-update-files.component';
import { FsCreateFolderButtonComponent } from './components/file-system/fs-create-folder-button/fs-create-folder-button.component';
import { FsFilterButtonComponent } from './components/file-system/fs-filter-button/fs-filter-button.component';
import { FileUploaderComponent } from './components/file-uploader/file-uploader.component';
import { BitfBytesPipe } from '@common/libs/bitforce/pipes/bitf-bytes.pipe';
import { FsCreateFilesButtonComponent } from './components/file-system/fs-create-files-button/fs-create-files-button.component';
import { BitfDndFileComponent } from '@common/libs/bitforce/core/components/ui/dnd-file';
import { FsCreateItemComponent } from './components/file-system/fs-create-item/fs-create-item.component';
import { FsSearchComponent } from './components/file-system/fs-search/fs-search.component';
import { BitfMatSearchComponent } from '@common/libs/bitforce/core/components/ui/search/material/bitf-mat-search.component';
import { NoDataComponent } from './components/no-data/no-data.component';
import { FormErrorDirective } from './directives/form-error/form-error.directive';
import { TooltipDirective } from './directives/tooltip/tooltip.directive';
import { AutofocusDirective } from './directives/autofocus/autofocus.directive';
import { FormSubmitDirective } from './directives/form-submit/form-submit.directive';
import { BitfClipboardDirective } from '@common/libs/bitforce/directives/bitf-clipbard.directive';
import { NoCopyPasteDirective } from './directives/no-copy-paste/no-copy-paste.directive';
import { BitfDatePipe } from '@common/libs/bitforce/pipes/bitf-date.pipe';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
// tslint:enable:max-line-length
registerLocaleData(localeIt);

const SHARED_MODULES = [
  CommonSharedModule,
  RouterModule,
  MATERIAL_MODULES,
  CDK_MODULES,
  FullCalendarModule,
  CKEditorModule,
  CarouselModule,
];
const SHARED_COMPONENTS = [
  BitfLoaderComponent,
  SearchComponent,
  HeaderComponent,
  HeaderLogoComponent,
  NewsContainerComponent,
  NewsComponent,
  CalendarContainerComponent,
  CalendarComponent,
  CalendarEventDialogComponent,
  BitfMatPaginatorComponent,
  NewsDialogComponent,
  BitfMatFormItemComponent,
  BitfMatFormOptionComponent,
  BitfCkFormItemComponent,
  BitfMatSortComponent,
  BitfMatInfiniteScrollTriggerComponent,
  FsContainerComponent,
  FsCardItemComponent,
  FsListItemComponent,
  FsActionsComponent,
  BitfMatBreadcrumbsComponent,
  FsFilterComponent,
  FsCreateUpdateFilesComponent,
  FsCreateFolderButtonComponent,
  FsFilterButtonComponent,
  FileUploaderComponent,
  FsCreateFilesButtonComponent,
  BitfDndFileComponent,
  FsCreateItemComponent,
  FsSearchComponent,
  BitfMatSearchComponent,
  NoDataComponent,
];
const SHARED_DIRECTIVES = [
  FormErrorDirective,
  TooltipDirective,
  AutofocusDirective,
  FormSubmitDirective,
  BitfClipboardDirective,
  BitfUiRoleManagerDirective,
  NoCopyPasteDirective,
  BitfSafeHtml,
];
const SHARED_PIPES = [BitfBytesPipe, BitfDatePipe];

@NgModule({
  imports: [...SHARED_MODULES],
  exports: [...SHARED_MODULES, ...SHARED_COMPONENTS, ...SHARED_DIRECTIVES, ...SHARED_PIPES],
  declarations: [...SHARED_COMPONENTS, ...SHARED_DIRECTIVES, ...SHARED_PIPES],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    { provide: DateAdapter, useClass: DateAdapterService },
    {
      provide: LOCALE_ID,
      useValue: 'it-IT',
      // deps: [BitfDynamicLocaleService],
      // useFactory: (dynamicLocaleService: BitfDynamicLocaleService) => dynamicLocaleService.defaultLocale.code,
    },
  ],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [],
    };
  }
}
